import React, { useState } from 'react';
import clsx from 'clsx';
import _isNumber from 'lodash/isNumber';
import Image from 'next/image';

import { ReviewRating } from './reviewRating';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { ListingUserReviewType } from '@utils/types/review';
import { ListingType } from '@utils/types/listing';
import {
  INIT_REVIEW_COUNT,
  getSourceIcon,
} from '@components/listing/listingReview/utils';
import { Review } from '@components/listing/listingReview/review';

import styles from './styles.module.scss';

type Props = {
  reviews: ListingUserReviewType[];
  rating: number;
  reviewAverages: ListingType['review_averages'];
  reviewAveragesBySource: ListingType['review_averages_by_source'];
  reviewsCount?: number;
} & BaseComponentProps;

ListingReview.defaultProps = {};

export function ListingReview(props: Props) {
  const {
    containerStyle,
    rating,
    reviewAverages,
    reviewAveragesBySource,
    reviewsCount,
    reviews,
  } = props;
  const [showAll, setShowAll] = useState(false);

  return (
    <div className={clsx([styles.reviewsContainer, containerStyle])}>
      {_isNumber(reviewsCount) && (
        <div className={styles.title}>{reviewsCount} Reviews</div>
      )}

      <div className={styles.platformRatings}>
        <div className={styles.platformRatings__item}>
          <div>All Platforms</div>
          <ReviewRating rating={rating} type="platform" />
        </div>

        {reviewAveragesBySource.map((r, index) => (
          <div
            key={`rating--${index}`}
            className={styles.platformRatings__item}
          >
            <Image src={getSourceIcon(r.source)} alt="source icon" />
            <ReviewRating rating={+r.rating || r.overall} type="platform" />
          </div>
        ))}
      </div>

      <div className={styles.ratings}>
        {Object.entries(reviewAverages).map(([key, value], index) => {
          if (key === 'overall') return null;
          return (
            <div key={`rating--${index}`} className={styles.ratings__item}>
              <div className={styles.ratings__value}>
                {(value || 0).toFixed(1)}
              </div>
              <div className={styles.ratings__label}>
                {key === 'checkin' ? 'check-In' : key}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.reviews}>
        {reviews
          .slice(0, showAll ? reviews.length : INIT_REVIEW_COUNT)
          .map((r, index) => (
            <Review key={`review--${index}`} review={r} />
          ))}
      </div>

      {reviews.length > INIT_REVIEW_COUNT && (
        <div
          className={styles.readMore}
          role="button"
          onClick={() => setShowAll((v) => !v)}
        >
          {showAll ? '- Show less' : '+ Show more'}
        </div>
      )}
    </div>
  );
}
